import { Grid2 as Grid, Paper, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useTranslation } from 'react-i18next';

export default function DashboardEmptyState() {
  const { t } = useTranslation(['description']);

  return (
    <Paper variant="outlined">
      <Grid
        container
        size={{ xs: 12 }}
        spacing={2}
        sx={{
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 400,
        }}
      >
        <Grid size="auto">
          <AccessTimeIcon color="secondary" sx={{ fontSize: 60 }} />
        </Grid>

        <Grid size="auto">
          <Typography variant="body1">
            {t('payments.dashboard.no_data')}
          </Typography>
        </Grid>

        <Grid size="auto">
          <Typography variant="body2" align="center">
            {t('payments.dashboard.no_data_description')}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}
